export const MENUITEMS = [
  {
    menutitle: 'Principal',
    menucontent: 'Dashboard e disparos',
    Items: [
      { title: 'Painel de Controle', icon: 'home',            type: 'link', path: '/dashboard',  active: false },
      { title: 'Agentes',            icon: 'user',            type: 'link', path: '/agentes',    active: false },
      { title: 'Time Comercial',     icon: 'others',          type: 'link', path: '/time',       active: false },
{ title: 'Conexões',           icon: 'support-tickets', type: 'link', path: '/conexoes',   active: false },
      { title: 'Listas',             icon: 'editors',         type: 'link', path: '/listas',     active: false },
      { title: 'Campanhas',          icon: 'social',          type: 'link', path: '/campanhas',  active: false },
      { title: 'Conversas',          icon: 'chat',            type: 'link', path: '/conversas',      active: false },
      { title: 'Configurações',      icon: 'settings',        type: 'link', path: '/configuracoes',  active: false },
    ],
  },
];

export const ADMIN_MENUITEMS = [
  {
    menutitle: 'Admin',
    menucontent: 'Gestão de tenants',
    Items: [
      { title: 'Admin',      icon: 'user',            type: 'link', path: '/admin/dashboard', active: false },
      { title: 'Tenants',    icon: 'others',          type: 'link', path: '/admin/tenants',   active: false },
    ],
  },
];
